import { defineMessages } from '@sm/intl';

const COPY = defineMessages({
  SIGN_UP_DISCLAIMER: {
    id: 'EnterpriseThankYou.copy.SignUpDisclaimer',
    defaultMessage:
      'By clicking “Get Started”, you agree to the <a href="/mp/legal/terms-of-use/">Terms of Use</a> and <a href="/mp/legal/privacy-policy/">Privacy Policy</a>. You also agree to receive information and offers relevant to our services via email. You can opt-out of these emails in your My Account page anytime.',
    description:
      '[Type: Button][Vis: high] - A legal disclaimer containing links to legal documents Terms of Service and Privacy Policy',
  },
  SIGN_UP_CALLOUT_SUB_HEADER: {
    id: 'EnterpriseThankYou.copy.SignUpCalloutSubHeader',
    defaultMessage:
      'Gather opinions from customers, employees, prospects, and more. Use your insights to make better, data-driven decisions.',
    description:
      "[Type: Header][Vis: high] - The Hero's subheader. A value proposition, giving a clear example of what they can get if they fill out the form below.",
  },
  POWERED_BY_TEXT: {
    id: 'EnterpriseThankYou.copy.PoweredByText',
    defaultMessage: 'Powered by',
    description:
      '[Type: Label][Vis: med] - This figure of speech is used to introduce and display the SurveyMonkey Logo',
  },
  THANK_YOU: {
    id: 'EnterpriseThankYou.copy.EnterpriseThankYouMessage',
    defaultMessage: 'Thank you for taking this survey',
    description:
      '[Type: Header][vis: high] - Header message on webpage. Used on a Nonbranded webpage to say thank you to survey respondents and signal the end of the survey.',
  },
  SIGN_UP_FORM_CTA_EMAIL_ADDRESS: {
    id: 'EnterpriseThankYou.copy.SignUpFormCTAEmailAddress',
    defaultMessage: 'Email Address',
    description: '[Type: Label][Vis: high] - The Label for an email input field.',
  },
  SIGN_UP_FORM_CTA_PASSWORD: {
    id: 'EnterpriseThankYou.copy.SignUpFormCTAPassword',
    defaultMessage: 'Password',
    description: '[Type: Label][Vis: high] - The Label for a password input field.',
  },
  SIGN_UP_FORM_CTA_SUBMIT: {
    id: 'EnterpriseThankYou.copy.SignUpFormCTASubmit',
    defaultMessage: 'Get started',
    description:
      '[Type: Button][Vis: high] - The button users are required to click to create an account using the values they entered in the email and password feilds.',
  },
  LOGO_PLACEHOLDER: {
    id: 'EnterpriseThankYou.copy.EnterpriseLogoPlaceholder',
    defaultMessage: 'Logo',
    description: '[Type: LogoText][Vis: low] - Logo placeholder text for a page header.',
  },
});

export default COPY;
